import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import useElementSize from '../../hooks/useElementSize';

import { useUrlFromHandle } from '../../contexts/RoutesContext';
import EventList from '../lists/EventList';

import styles from '../../../styles/blocks/events.module.scss';

const propTypes = {
    title: PropTypes.string,
    query: PropTypes.shape({}),
    withDetails: PropTypes.bool,
    isContainer: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    query: null,
    withDetails: false,
    isContainer: false,
    className: null,
    containerClassName: null,
};

const EventsBlock = ({ title, query, isContainer, withDetails, className, containerClassName }) => {
    const ref = useRef(null);
    const { current } = ref || null;
    const { width: gridWidth = null } = useElementSize(current);

    let columns = null;
    if (gridWidth !== null) {
        if (gridWidth < 650) {
            columns = 1;
        } else if (gridWidth > 650 && gridWidth < 1440) {
            columns = 2;
        } else if (gridWidth > 1440) {
            columns = 3;
        }
    }

    const handle = useUrlFromHandle();

    return (
        <div
            ref={ref}
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <div
                className={classNames([
                    'blockEvents',
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <EventList
                    title={title}
                    query={query}
                    cardType={withDetails ? 'event' : 'square'}
                    columns={!withDetails ? columns : null}
                    link={{
                        href: handle('calendar'),
                        label: (
                            <FormattedMessage
                                defaultMessage="View full calendar"
                                description="Button label"
                            />
                        ),
                    }}
                />
            </div>
        </div>
    );
};

EventsBlock.propTypes = propTypes;
EventsBlock.defaultProps = defaultProps;

export default EventsBlock;
